import { render, staticRenderFns } from "./ConsignmentTypeSelector.vue?vue&type=template&id=6dbc48ea&scoped=true"
import script from "./ConsignmentTypeSelector.vue?vue&type=script&lang=js"
export * from "./ConsignmentTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc48ea",
  null
  
)

export default component.exports